import { JsonObject } from 'ta-json';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_currencyOptions,
} from '@src/app/generated/GetAllRetailers';
import { CurrencyOptions } from '@ess/jg-rule-executor/dist/src/domain/currency-options';
import { CurrencyOptionsInput } from '@src/app/generated/globalTypes';

/**
 * CurrencyOptions
 */
@JsonObject()
export class PortalCurrencyOptions extends CurrencyOptions {
  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_currencyOptions): PortalCurrencyOptions {
    return new PortalCurrencyOptions(
      gql.currency,
      gql.showCurrency,
      gql.locale,
      gql.showThousandsSeparator
    );
  }

  toGqlInput(): CurrencyOptionsInput {
    return {
      currency: this.currency,
      showCurrency: this.showCurrency,
      locale: this.locale,
      showThousandsSeparator: this.showThousandsSeparator,
    };
  }
}
